import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations/translations';
import SEO from '../components/SEO';
import { useTheme } from '../context/ThemeContext';

const sponsors = [
  { name: 'BeGood.no', url: 'https://begood.no', descriptionKey: 'samarbeid.begoodDesc' },
  { name: 'Rasklading.no', url: 'https://rasklading.no', descriptionKey: 'samarbeid.raskladingDesc' },
];

const secondarySponsors = [
  { name: 'Tesla', url: 'https://teslano.roamingnorway.com', descriptionKey: 'samarbeid.teslaDesc' },
];

const Samarbeid = () => {
  const { language } = useLanguage();
  const { darkMode } = useTheme();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-24">
      <SEO
        title="Samarbeid"
        path="/samarbeid"
        description="Effekt samarbeider med ledende aktører innen elbil og lading."
      />
      <div className="max-w-4xl w-full text-center">
        <h1 className={`text-4xl sm:text-5xl md:text-6xl font-bold mb-6 ${darkMode ? 'text-gray-100' : 'text-stone-900'}`}>
          {t(language, 'samarbeid.title')}
        </h1>
        <p className={`text-xl sm:text-2xl mb-16 font-light ${darkMode ? 'text-gray-400' : 'text-stone-500'}`}>
          {t(language, 'samarbeid.subtitle')}
        </p>

        <div className="grid gap-8 sm:grid-cols-2">
          {sponsors.map((sponsor) => (
            <a
              key={sponsor.name}
              href={sponsor.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group rounded-2xl p-8 border transition-all duration-150 ${darkMode ? 'bg-slate-800 border-teal-500 border-opacity-30 hover:border-opacity-60 hover:shadow-teal-500/20' : 'bg-white border-stone-200 hover:border-teal-500 shadow-sm hover:shadow-md'}`}
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-teal-500 group-hover:text-teal-400 transition-colors duration-150 mb-4">
                {sponsor.name}
              </h2>
              <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-stone-600'}`}>
                {t(language, sponsor.descriptionKey)}
              </p>
            </a>
          ))}
        </div>

        <h2 className={`text-xl sm:text-2xl font-bold mt-20 mb-8 ${darkMode ? 'text-gray-400' : 'text-stone-400'}`}>
          {t(language, 'samarbeid.referralTitle')}
        </h2>
        <div className="flex justify-center gap-6 flex-wrap">
          {secondarySponsors.map((sponsor) => (
            <a
              key={sponsor.name}
              href={sponsor.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group rounded-xl p-5 border transition-all duration-150 ${darkMode ? 'bg-slate-800 border-teal-500 border-opacity-20 hover:border-opacity-50' : 'bg-white border-stone-200 hover:border-teal-500 shadow-sm hover:shadow-md'}`}
            >
              <h3 className="text-lg sm:text-xl font-bold text-teal-500 group-hover:text-teal-400 transition-colors duration-150 mb-2">
                {sponsor.name}
              </h3>
              <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-stone-500'}`}>
                {t(language, sponsor.descriptionKey)}
              </p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Samarbeid;
